import * as types from 'constants/ActionTypes';

export const loadManagePaymentOptionsPage = () => ({ type: types.LOAD_MANAGE_PAYMENT_OPTIONS_PAGE });

export const updateManagePaymentsCardDetails = (cardDetails) => ({ type: types.UPDATE_MANAGE_PAYMENTS_CARD_DETAILS, cardDetails });

export const updateManagePaymentsCardConsent = (ccConsent) => ({ type: types.UPDATE_MANAGE_PAYMENTS_CARD_CONSENT, ccConsent });

export const updatePurchaseOrderValue = ({ purchaseOrder }) => ({ type: types.UPDATE_MANAGE_PAYMENT_PURCHASE_ORDER_VALUE, purchaseOrder });

export const closeManagePaymentsOption = () => ({
  type: types.CLOSE_SUSPEND_PREPAY_OPTIONS_BANNER,
  managePaymentsBanner: {
    open: false,
    severity: '',
    message: '',
  },
});
